module.exports = __webpack_public_path__ + "img/btn2.cd919048.png";